(ns app.front.ui.phrase-code-modal
  (:require [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.phrase :as phrase]
            [app.front.view.group.subs :as group-subs]
            [app.front.view.model-codes.selector :as model-codes-selector]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::data :-> ::data)


(rf/reg-event-fx ::open-phrase-code-modal
  (fn [{:keys [db]} [_ parent-id group-id default-phrase-category]]
    {:db (assoc-in db [::data :phrase-code-modal-open? parent-id] true)
     :fx [[:dispatch [::phrase/set-selected-category default-phrase-category]]
          [:dispatch [::model-codes-selector/init group-id]]]}))


(rf/reg-event-db ::close-phrase-code-modal
  (fn [db _]
    (-> db
        (p/dissoc-in [::data :phrase-code-modal-open?])
        (p/dissoc-in [::data :selected-section-path]))))


(rf/reg-sub ::phrase-code-modal-open?
  (fn [db [_ id]]
    (get-in db [::data :phrase-code-modal-open? id])))


(rf/reg-event-db ::set-phrase-code-tab
  (fn [db [_ tab]]
    (assoc-in db [::data :phrase-code-tab] tab)))


(rf/reg-sub ::phrase-code-tab
  :<- [::data]
  :-> :phrase-code-tab)


(defn phrase-select [tr id insert-text phrases default-phrase-category rt-editor]
  (if (<sub [::ws-subs/loading-config?])
    (cc/skeleton-text {})
    [:div [phrase/phrase-selector {:tr               tr
                                   :default-category default-phrase-category
                                   :phrases          phrases
                                   :editing?         true
                                   :id               id
                                   :on-change        insert-text
                                   :rt-editor        rt-editor}]]))


(defn modal [tr id editor insert-fragment on-change code-reference-fn phrases default-phrase-category group-id]
  (let [open?          (<sub [::phrase-code-modal-open? id])
        close-modal-fn #(>evt [::close-phrase-code-modal])
        current-tab    (<sub [::phrase-code-tab])
        insert-phrase  (partial insert-fragment on-change false)
        insert-text    (partial insert-fragment on-change)]
    [ui-modal/composed-input-modal
     {:id         (str id "-phrase-code-modal")
      :open       open?
      :on-close   close-modal-fn
      :size       :lg
      :class-name "phrase-modal"
      :style      {:z-index 9100}} ;; Other modals can open this, so get on top of them.
     (cc/modal-header {:close-modal close-modal-fn
                       :title       (tr [:phrase/add-phrase-or-code])})
     (cc/modal-body
       {}
       [::div.flex-grow.overflow-y-auto.pb-2
        [ui-cs/content-switcher
         {:items     (cond-> [:standard-texts.tabs/phrases]
                       (<sub [::group-subs/has-feature? group-id :group.feature/model-codes-integration])
                       (conj :standard-texts.tabs/model-codes))
          :val->str  #(tr [%])
          :current   current-tab
          :on-change #(>evt [::set-phrase-code-tab %])}]
        [:div.mt-4
         (case current-tab
           (:standard-texts.tabs/phrases nil)
           [phrase-select tr id insert-phrase phrases default-phrase-category editor]

           :standard-texts.tabs/model-codes
           [model-codes-selector/model-code-select (util/mmap id
                                                              tr
                                                              editor
                                                              insert-text
                                                              code-reference-fn
                                                              group-id)])]])
     (cc/modal-footer {}
                      (cc/button {:kind     :secondary
                                  :on-click close-modal-fn}
                                 (tr [:close])))]))
